import styled from 'styled-components/native';

const Component = styled.StatusBar.attrs(({ theme }) => ({
  backgroundColor: theme.colors?.background,
  translucent: false,
  showHideTransition: 'fade',
  hidden: false,
  barStyle: 'dark-content',
}))``;

Component.displayName = 'VisibleStatusBar';

export default Component;
